import { render, staticRenderFns } from "./footer-head.vue?vue&type=template&id=5192721a&scoped=true"
import script from "./footer-head.vue?vue&type=script&lang=js"
export * from "./footer-head.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5192721a",
  null
  
)

export default component.exports